import { render, staticRenderFns } from "./TotalProd.vue?vue&type=template&id=e10d90a6&scoped=true"
import script from "./TotalProd.vue?vue&type=script&lang=js"
export * from "./TotalProd.vue?vue&type=script&lang=js"
import style0 from "./TotalProd.vue?vue&type=style&index=0&id=e10d90a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10d90a6",
  null
  
)

export default component.exports